import { Currency } from './Currency.js';
import { LedgerBalance } from './LedgerBalance.js';
import { MonetaryValueWithCurrency } from './MonetaryValueWithCurrency.js';
export class MonetaryLedgerBalance extends MonetaryValueWithCurrency {
    constructor(value, currency) {
        super(value, currency);
    }
    construct(value, currency) {
        return new MonetaryLedgerBalance(value, currency);
    }
    /**
     * The currencyless zero singleton — the additive identity for MonetaryLedgerBalance.
     */
    static ZERO = new MonetaryLedgerBalance(LedgerBalance.create('0', null), null);
    /**
     * Creates a MonetaryLedgerBalance from a LedgerBalance value.
     * @param value - The LedgerBalance value.
     * @param currency - The Currency object or CurrencyCode.
     * @returns A new MonetaryLedgerBalance instance.
     */
    static from(value, currency) {
        return MonetaryValueWithCurrency.createFromValue(value, currency, (v, c) => new MonetaryLedgerBalance(v, c));
    }
    /**
     * Creates a zero MonetaryLedgerBalance.
     *
     * When called without a currency, returns the ZERO singleton.
     * When called with a currency, returns a zero amount preserving currency info.
     *
     * @param currency - Optional currency. If omitted, returns the ZERO singleton.
     * @returns A MonetaryLedgerBalance with value 0.
     */
    static zero(currency) {
        if (currency === undefined) {
            return MonetaryLedgerBalance.ZERO;
        }
        const currencyObject = currency instanceof Currency ? currency : Currency.fromCode(currency);
        return new MonetaryLedgerBalance(LedgerBalance.create('0', null), currencyObject);
    }
}
//# sourceMappingURL=MonetaryLedgerBalance.js.map